import React, {useState} from 'react'
import Tabs from './FormElements/Tabs/index';
import SubjectForm  from './FormLayout/SubjectForm';
import LessonForm from './FormLayout/LessonForm';
import RandomForm from './FormLayout/RandomForm';

const Index = () => {
  const [activeTab, setActiveTab] = useState('subjectForm');

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };
  return (
    <div>
    <Tabs onTabChange={handleTabChange} activeTab={activeTab} />
    {activeTab === 'subjectForm' && <SubjectForm />}
    {activeTab === 'lessonForm' && <LessonForm />}
    {activeTab === 'randomForm' && <RandomForm />}
  </div>
  )
}

export default Index